import { SignUpFormGoal } from "@redotech/redo-model/signup-form";
import { signupFormSchema } from "@redotech/redo-model/signup-form-schema";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getFormsByGoal = {
  name: "getFormsByGoal" as const,
  input: z.object({ goal: createEnum(SignUpFormGoal) }),
  output: z.array(
    z.object({
      id: z.string(),
      form: signupFormSchema,
      publishedAt: z.date().nullable(),
    }),
  ),
};
